import React from 'react';
import { cn } from '../../utils/cn.js';

export const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    className,
    onClick,
    ...props
}) => {

    const baseStyles = "relative inline-flex items-center justify-center font-bold tracking-wide transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:pointer-events-none overflow-hidden";

    const variants = {
        primary: `
      bg-gradient-to-r from-cyan-500 to-blue-600 
      text-white 
      shadow-[0_0_20px_rgba(6,182,212,0.4)] hover:shadow-[0_0_30px_rgba(6,182,212,0.6)]
      border-0 ring-1 ring-cyan-400/20
    `,
        secondary: `
      bg-white/5 backdrop-blur-md
      text-slate-300 hover:text-white
      border border-white/10 hover:bg-white/10
      shadow-lg
    `,
        danger: `
      bg-gradient-to-r from-red-500 to-pink-600
      text-white
      shadow-[0_0_20px_rgba(239,68,68,0.4)]
    `,
        outline: `
      bg-transparent border-2 border-white/20 text-white hover:border-white/50
    `
    };

    const sizes = {
        sm: "h-9 px-4 text-xs rounded-lg",
        md: "h-12 px-6 text-sm rounded-xl",
        lg: "h-14 px-8 text-base rounded-2xl",
        xl: "h-16 px-10 text-lg rounded-2xl w-full"
    };

    return (
        <button
            onClick={onClick}
            className={cn(baseStyles, variants[variant], sizes[size], className)}
            {...props}
        >
            {/* Shine Effect */}
            <div className="absolute inset-0 -translate-x-[100%] group-hover:translate-x-[100%] transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12" />

            <span className="relative z-10 flex items-center gap-2">
                {children}
            </span>
        </button>
    );
};
